import { useMemo } from 'react';

import type { RedditShareRecommendations } from '../../../hooks/useFetchShareRecommendations';

type UseSortedRecommendations = ModelHookResult<{
	sortedRecommendations: RedditShareRecommendations;
}>;

export function useSortedRecommendations(recommendations: RedditShareRecommendations): UseSortedRecommendations {
	const sortedRecommendations = useMemo(() => {
		if (recommendations.length === 0) return [];

		return [...recommendations].sort((a, b) => {
			const aCount = a.metadata.memberCount ?? -Infinity;
			const bCount = b.metadata.memberCount ?? -Infinity;

			return bCount - aCount;
		});
	}, [recommendations]);

	return {
		data: {
			sortedRecommendations,
		},
	};
}
